module.exports = __webpack_public_path__ + "img/H-45-ER-1000-BB.43bc290f.png";